import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AiOutlineCompass } from "react-icons/ai";
import { ImPushpin } from "react-icons/im";
import { MdOutlineLocalActivity } from "react-icons/md";
import { VscGlobe } from "react-icons/vsc";
import PostsBoard from "../Components/Posts/PostsBoard";
import LinkWithSearchParams from "../Components/UI/LinkWithSearchParams";
import PostComposer from "../Components/Posts/PostComposer";
import { GiHighFive } from "react-icons/gi";
import { useStore } from "../utils/store";
import { fetchIDOs, fetchSuggestedProfiles } from "../utils/apis";
import ProfileBadge from "../Components/UI/ProfileBadge";
import LaunchPadCard from "../Components/LaunchPad/LaunchPadDashboard/LaunchPadCard";
import { getEllipsisTxt } from "../helpers/formatters";

const NewsFeed = () => {
    const { "*": slug } = useParams();

    const profile = useStore((state) => state.profile);
    const followOthersProfile = useStore((state) => state.followOthersProfile);
    const [suggestedProfiles, setSuggestedProfiles] = useState([]);
    const [idos, setIdos] = useState([]);

    useEffect(() => {
        const loadSuggestedProfiles = async () => {
            if (!profile?.wallet) return;
            if (suggestedProfiles.length > 0) return;
            const _suggestedProfiles = await fetchSuggestedProfiles(
                profile.wallet
            );

            if (!_suggestedProfiles.length > 0) {
                setSuggestedProfiles([]);
                return;
            }
            setSuggestedProfiles(_suggestedProfiles);
        };
        loadSuggestedProfiles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    useEffect(() => {
        const loadIDOs = async () => {
            const _idos = await fetchIDOs();

            if (!_idos.length > 0) {
                setIdos([]);
                return;
            }

            setIdos(_idos);
        };
        loadIDOs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex flex-col main-container animation-fade-in gap-6 pt-6 pb-6">
            {/* <h5 className="page-subtitle">Explore New Ideas</h5> */}
            <div className="flex flex-col md:flex-row justify-center gap-x-8">
                <div className="flex flex-col w-full md:w-64 min-w-[16rem]">
                    {/* sticky top-0 */}
                    <div className="flex flex-col bg-[#222232] rounded-lg py-4 px-4 gap-2 mb-4">
                        {LINKS_LIST.map((link, index) => (
                            <LinkWithSearchParams
                                key={index}
                                className={({ isActive }) =>
                                    `flex items-center group hover:text-kadGrSt duration-150 p-2 rounded-lg hover:bg-kadComponentBorder hover:shadow-lg ${
                                        isActive
                                            ? "text-kadGrSt bg-kadComponentBorder"
                                            : "text-white"
                                    }`
                                }
                                to={{
                                    pathname: link.path,
                                }}
                            >
                                {link.icon}
                                <span className="ml-2">{link.text}</span>
                            </LinkWithSearchParams>
                        ))}
                    </div>
                </div>
                <div className="w-full flex flex-col max-w-[40rem]">
                    {!slug?.includes("-") &&
                        slug !== "featured" &&
                        slug !== "discover" &&
                        slug !== "trending" && <PostComposer />}
                    {slug === "featured" && (
                        <h2 className="text-center text-kad-gradient">
                            Featured Posts
                        </h2>
                    )}
                    {slug === "trending" && (
                        <h2 className="text-center text-kad-gradient">
                            Trending #Posts
                        </h2>
                    )}
                    {slug === "discover" && (
                        <h2 className="text-center text-kad-gradient">
                            Search Posts
                        </h2>
                    )}
                    <PostsBoard />
                </div>
                <div className="hidden md:flex flex-col gap-2 w-full md:w-64 min-w-[16rem]">
                    <h5>Who to follow</h5>
                    {suggestedProfiles.map((userProfile, index) => (
                        <div className="flex w-full gap-4" key={index}>
                            <ProfileBadge profile={userProfile} />
                            <div className="flex flex-col w-full">
                                <div className="flex">
                                    {userProfile.username === userProfile.wallet
                                        ? getEllipsisTxt(
                                              userProfile.username,
                                              4
                                          )
                                        : userProfile.username}
                                    <button
                                        className="profile-follow ml-auto"
                                        onClick={() =>
                                            followOthersProfile(
                                                userProfile.username
                                            )
                                        }
                                    >
                                        {profile?.following?.includes(
                                            userProfile?.wallet
                                        )
                                            ? "Following"
                                            : "Follow"}
                                    </button>
                                </div>
                                <span className="size-sm font-light opacity-70 profile-badge-bio">
                                    {userProfile.bio || "-"}
                                </span>
                            </div>
                        </div>
                    ))}
                    <h5 className="mt-4">Upcoming IDOs</h5>
                    {idos.map((el, i) => (
                        <LaunchPadCard
                            key={i}
                            {...el}
                            offChainData={el}
                            progress={0}
                            presaleAddress={el.address}
                            status="PRESALE_UPCOMING"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewsFeed;

const LINKS_LIST = [
    {
        icon: <MdOutlineLocalActivity className="size-2" />,
        path: "/feeds/activity",
        text: "Activity Feeds",
    },
    {
        icon: <ImPushpin className="size-2" />,
        path: "/feeds/featured",
        text: "Featured",
    },
    { icon: <VscGlobe className="size-2" />, path: "/feeds/all", text: "All" },
    {
        icon: <AiOutlineCompass className="size-2" />,
        path: "/feeds/discover",
        text: "Discover",
    },
    {
        icon: <GiHighFive className="size-2" />,
        path: "/feeds/trending",
        text: "Trending",
    },
];
